<!-- [ai-generated-code] -->
<div class="container-box">
  <app-table-header
    (btnUpdateClick)="reloadTrigger$.next()"
    [showNewButton]="false"
    tableTitle="Tabella anagrafica telai"
  ></app-table-header>
  <div>
    <div class="table-container">
      <app-new-table
        [dataSource]="dataSource"
        [displayedColumns]="displayedColumns"
        [initialSort]="{
          active: 'id',
          direction: 'desc'
        }"
        [reloadTrigger$]="reloadTrigger$"
      ></app-new-table>
    </div>
  </div>
</div>
